import axios from "../../config/axiosConfig";
import { CREATE_REMINDER, GET_REMINDER, REMINDER_REQUEST, DELETE_REMINDER, UPDATE_REMINDER, REMINDER_REQUEST_FAILURE } from "../types";
import { addMasterInOption, updateMasterInOption } from "./master-options-actions";

export const getReminders = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: REMINDER_REQUEST });
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id, userId: auth.user?.id, companyId: auth.company?.id };
      if (!auth?.company?.Common_Master) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/reminder/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_REMINDER, payload: response.data });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: REMINDER_REQUEST_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: REMINDER_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const createReminder = (reminder) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: REMINDER_REQUEST });
      return axios.post("/reminder/add", reminder,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id }}
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_REMINDER, payload: response.data });
        //   dispatch(addMasterInOption('reminders', response.data));
        } else {
          dispatch({
            type: REMINDER_REQUEST_FAILURE,
            error: "Reminder create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: REMINDER_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: REMINDER_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateReminder = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: REMINDER_REQUEST });
      const { auth } = getState();
      return axios.put("/reminder/update", { id, data }, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_REMINDER,
            payload: { id, data: response.data },
          });
        //   dispatch(updateMasterInOption('reminders', id, response.data));
        } else {
          dispatch({
            type: REMINDER_REQUEST_FAILURE,
            error: "Reminder update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: REMINDER_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: REMINDER_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteReminder = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: REMINDER_REQUEST });
      return axios.delete(`/reminder/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_REMINDER, id: id });
        //   dispatch(updateMasterInOption('reminders', id));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: REMINDER_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: REMINDER_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};
